var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.plaintext)?_c('span',{staticClass:"col-form-label d-block"},[_vm._v(_vm._s(_vm.displayText))]):_c('treeselect',_vm._g({attrs:{"value":_vm.value,"multiple":false,"options":_vm.storages,"disable-branch-nodes":_vm.disableBranchNodes,"disabled":_vm.disabled,"clearable":_vm.clearable}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }